import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="components--state-select"
export default class extends Controller {
  static get targets() {
    return ['state', 'city'];
  }

  stateChange(event) {
    const stateId = event.currentTarget.value;
    const citySelect = this.cityTarget;
    const { selectize } = citySelect;
    selectize.clear();
    selectize.clearOptions();
    if (stateId !== '') {
      fetch(`/states/${stateId}/cities`)
        .then((response) => response.json())
        .then((cities) => {
          selectize.addOption(cities);
          selectize.refreshOptions();
        });
    }
  }
}
